import { useStyles } from "./FiltersDefaultButton.styles";
import { IFullScreenButtonProps } from "./FiltersDefaultButtonInterfaces";
import { useTranslation } from "react-i18next";

export const FiltersDefaultButton = ({
    isSelected,
    handleOperation,
    hasDefault,
    disabled,
    customStyles,
}: IFullScreenButtonProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div
            style={customStyles}
            className={disabled ? classes.headerActionWrapperDisabled : classes.headerActionWrapper}
            onClick={async () => (disabled ? {} : await handleOperation())}
        >
            {isSelected
                ? t("locations.mill_dashboards.remove_default_filters")
                : hasDefault
                ? t("locations.mill_dashboards.update_default_filters")
                : t("locations.mill_dashboards.save_default_filters")}
        </div>
    );
};
